import { Injectable } from '@angular/core';
import { ActionSheetController, Platform } from 'ionic-angular';
import { FacebookServiceProvider } from '../facebook-service/facebook-service';

/*
  Generated class for the ShareServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ShareServiceProvider {
  constructor(
    public actionSheetCtrl: ActionSheetController,
    private facebookService: FacebookServiceProvider,
    public platform: Platform
  ) {}

  presentShare(
    actionSheetTitle = 'Share',
    link = 'https://ask.lubbu.com',
    title = 'Join Lubbu!',
    message = 'Ask for anything you want'
  ) {
    let linkTwitter = link.replace('#', '%23');
    let buttons: any = [
      {
        text: 'Email',
        role: 'destructive',
        icon: 'mail',
        cssClass: 'action-sheet-email',
        handler: () => {
          window.location.href = `mailto:?subject=${title}&body=${message}%0D%0A%0D%0A${link}%0D%0A`;
        }
      },
      {
        text: 'Facebook',
        role: 'destructive',
        icon: 'logo-facebook',
        cssClass: 'action-sheet-facebook',
        handler: () => {
          this.facebookService.share(link, title);
        }
      },
      {
        text: 'Twitter',
        role: 'destructive',
        icon: 'logo-twitter',
        cssClass: 'action-sheet-twitter',
        handler: () => {
          window.open(
            `https://twitter.com/intent/tweet?text=${title}  ${link}`,
            '_blank'
          );
        }
      }
    ];

    if (!this.platform.is('core')) {
      buttons.push({
        text: 'SMS',
        role: 'destructive',
        icon: 'phone-portrait',
        cssClass: 'action-sheet-sms',
        handler: () => {
          let ua = navigator.userAgent.toLowerCase();
          let url;
          if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1)
            url = 'sms:&body=' + encodeURIComponent(link);
          else url = 'sms:?body=' + encodeURIComponent(link);

          location.href = url;

          window.location.href = url; ////sms:+123456789&body=" + encodeURI(message_text)
        }
      });

      buttons.push({
        text: 'Whatsapp',
        role: 'destructive',
        icon: 'logo-whatsapp',
        cssClass: 'action-sheet-whatsapp',
        handler: () => {
          window.location.href =
            `whatsapp://send?text=` + link.replace('#', '%23');
        }
      });
    }

    buttons.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {}
    });

    let actionSheet = this.actionSheetCtrl.create({
      title: actionSheetTitle,
      buttons: buttons
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/share-service/share-service.ts